import styled from 'styled-components'

const HeaderCartAccountStyle = styled.div`
	--headerCartAccountMenuMarginLeft: var(--sp17x);
	--iconSize: var(--sp8x);
	--cartMarginLeft: var(--sp8x);

	.hide {
		display: none;
	}

	margin-left: var(--headerCartAccountMenuMarginLeft);

	.icon-profile,
	.icon-cart {
		fill: var(--orange);
		transition: var(--trTime2);

		width: var(--iconSize);
		height: var(--iconSize);

		@media (hover: hover) {
			&:hover {
				fill: var(--cream);
			}
		}
	}

	.cart-icon-cont {
		position: relative;

		.icon-cart {
			margin-left: var(--cartMarginLeft);
		}

		.items-count {
			position: absolute;
			top: calc(-0.4 * var(--iconSize));
			right: calc(-0.4 * var(--iconSize));
			background: var(--orange);
			width: calc(0.75 * var(--iconSize));
			height: calc(0.75 * var(--iconSize));
			border-radius: 50%;
			color: var(--cream);
			text-align: center;
			font-size: var(--mini);
			line-height: calc(0.75 * var(--iconSize));
			z-index: 0;
			font-family: maisonMedium;
			transition: var(--trTime2);
		}

		.icon-cart:hover + .items-count {
			color: var(--orange);
			background: var(--cream);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--headerCartAccountMenuMarginLeft: var(--sp15x);
		--iconSize: var(--sp5x);
		--cartMarginLeft: var(--sp5x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--headerCartAccountMenuMarginLeft: var(--sp12x);
		--iconSize: var(--sp4x);
		--cartMarginLeft: var(--sp4x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--headerCartAccountMenuMarginLeft: var(--sp11x);
		--iconSize: var(--sp4x);
		--cartMarginLeft: var(--sp4x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--headerCartAccountMenuMarginLeft: var(--sp7x);
		--iconSize: var(--sp4x);
		--cartMarginLeft: var(--sp3x);
		margin-left: auto;
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		margin-left: auto;
		--iconSize: var(--sp3x);
		--cartMarginLeft: var(--sp3x);
	}
`

export default HeaderCartAccountStyle
